export const LOGGED_IN = "LOGGED_IN";
export const LOGGED_OUT = "LOGGED_OUT";
export const LOGGING_IN = "LOGGING_IN";
export const ENTER_NEW_PASSWORD = "ENTER_NEW_PASSWORD";
export const LOGGING_IN_NEW_PASSWORD = "LOGGING_IN_NEW_PASSWORD";
export const FORGOT_PASSWORD = "FORGOT_PASSWORD";
export const FORGOT_PASSWORD_SUBMITTING = "FORGOT_PASSWORD_SUBMITTING";
